import { memo } from 'react'

import OpportunityFilterScreenDesktop from './OpportunityFilterScreen.desktop'
import { OpportunityFilterModalProps } from './OpportunityFilterScreen.types'
import { useOpportunityFilterScreen } from './useOpportunityFilterScreen'

const OpportunityFilterModalDesktop = ({
  navigation,
  route,
  onClose,
  onSubmit,
  initialListType
}: OpportunityFilterModalProps) => {
  const opportunityFilter = useOpportunityFilterScreen({
    navigation,
    route,
    onClose,
    onSubmit,
    initialListType
  })

  return <OpportunityFilterScreenDesktop {...opportunityFilter} />
}

export default memo(OpportunityFilterModalDesktop)
